import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {catchError} from 'rxjs/operators';
import {Observable, throwError} from 'rxjs';
import {AgentForceDataType} from '../../editor-interface/shared/models/left-toolbar.constants';

@Injectable({
  providedIn: 'root'
})
export class AgentforceService {
  apiUrl: string;
  constructor(private http: HttpClient) {
    this.apiUrl = environment.API_ENDPOINT;
  }

  generateAgentforceData(
    diagramId: string,
    state: string,
    type: AgentForceDataType
  ): Observable<{instructions: string; testUtterances: string}> {
    return this.http
      .get<{
        instructions: string;
        testUtterances: string;
      }>(`${this.apiUrl}/diagram/${diagramId}/state/${state}/${type}`)
      .pipe(catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse) {
    return throwError(error.error);
  }
}
